<template>
	<div :id="'template' + _uid" class="pt-2">
		<template v-if="test.body.shape == 'round'">
			<tongueRoundS
				v-if="test.body.size == 'small'"
				@mounted="init"
        :height="100"
        :width="90"
			/>
			<tongueRoundN
				v-else-if="test.body.size == 'normal'"
				@mounted="init"
        :height="100"
        :width="90"
			/>
			<tongueRoundL
        v-else
        @mounted="init"
        :height="100"
        :width="90"
      />
		</template>
		<template v-else-if="test.body.shape == 'square'">
			<tongueSquareS
				v-if="test.body.size == 'small'"
				@mounted="init"
        :height="100"
        :width="90"
			/>
			<tongueSquareN
				v-else-if="test.body.size == 'normal'"
				@mounted="init"
        :height="100"
        :width="90"
			/>
			<tongueSquareL
        v-else
        @mounted="init"
        :height="100"
        :width="90"
      />
		</template>
		<template v-else>
			<tongueTriangleS
				v-if="test.body.size == 'small'"
				@mounted="init"
        :height="100"
        :width="90"
			/>
			<tongueTriangleN
				v-else-if="test.body.size == 'normal'"
				@mounted="init"
        :height="100"
        :width="90"
			/>
			<tongueTriangleL
        v-else
        @mounted="initBoard"
        :height="100"
        :width="90"
      />
		</template>
	</div>
</template>

<script>
import tongueRoundS from "@/assets/icons/mtc/tongue/tongueRoundS.vue";
import tongueRoundN from "@/assets/icons/mtc/tongue/tongueRoundN.vue";
import tongueRoundL from "@/assets/icons/mtc/tongue/tongueRoundL.vue";
import tongueSquareS from "@/assets/icons/mtc/tongue/tongueSquareS.vue";
import tongueSquareN from "@/assets/icons/mtc/tongue/tongueSquareN.vue";
import tongueSquareL from "@/assets/icons/mtc/tongue/tongueSquareL.vue";
import tongueTriangleS from "@/assets/icons/mtc/tongue/tongueTriangleS.vue";
import tongueTriangleN from "@/assets/icons/mtc/tongue/tongueTriangleN.vue";
import tongueTriangleL from "@/assets/icons/mtc/tongue/tongueTriangleL.vue";

const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);
export default {
  name: "TongueTemplate",
  components: {
		tongueRoundS,
		tongueRoundN,
		tongueRoundL,
		tongueSquareS,
		tongueSquareN,
		tongueSquareL,
		tongueTriangleS,
		tongueTriangleN,
		tongueTriangleL
  },
  props: {
		test: {}
  },
  data: () => ({
    board: ""
  }),
  computed: {
    drawId() {
			return '#template' + this._uid + ' ';
		}
  },
  methods: {
    init() {
      this.board = $(this.drawId + "svg");
      
      console.log("INIT TEMPLATE");
      
      for (const [ key, value ] of Object.entries(this.test.body.parts)) {
				let path = $(this.drawId + '#' + key);
				path.style.fill = value.fill;
				path.setAttributeNS(null, "filter", value.filter);
			}

			for (const [ key, value ] of Object.entries(this.test.cover.parts)) {
				let path = $(this.drawId + '#' + key);
				path.style.fill = value.fill;
				path.setAttributeNS(null, "filter", value.filter);
			}

			for(let i = 0; i < this.test.body.elements.length; i++) {
				this.drawPath(this.test.body.elements[i]);
			}
			for(let i = 0; i < this.test.cover.elements.length; i++) {
				this.drawPath(this.test.cover.elements[i]);
			}
			for(let i = 0; i < this.test.marks.elements.length; i++) {
				this.drawPath(this.test.marks.elements[i]);
			}
      
      let layers = $$(this.drawId + 'svg g');
			this.board.insertBefore(layers[1], layers[0]);
    },
    drawPath(data) {
			let path = document.createElementNS("http://www.w3.org/2000/svg", "path");
			path.setAttributeNS(null, "d", data['d']);
			path.setAttributeNS(null, "fill", data['fill']);
			path.setAttributeNS(null, "stroke-linecap", data['stroke-linecap']);
			path.setAttributeNS(null, "stroke-linejoin", data['stroke-linejoin']);
			path.setAttributeNS(null, "stroke", data['stroke']);
			path.setAttributeNS(null, "stroke-width", data['stroke-width']);
			path.setAttributeNS(null, "filter", data['filter']);
			path.setAttribute("freeDraw", "true");
			path.setAttribute("type", data['type']);
			if(data['type'] == 'mark') path.setAttribute("kind", data['kind']);

			if(data['type'] == 'body') $(this.drawId + "#body_layer").appendChild(path);
			else if(data['type'] == 'cover' || data['type'] == 'mark') $(this.drawId + "#cover_layer").appendChild(path);

			return path
		},
  }
}
</script>